import React,{useState} from 'react'
import './Styles.css'
import logo from '../assets/Logo.png'


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header-tfft">
      <nav className="navbar-tfft">
        <a href="/" className="logo-tfft">
          <img src={logo} alt="VSN Granites" />
        </a>

        <div
          className={`hamburger-tfft ${menuOpen ? "open-tfft" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </div>

        <ul className={`nav-links-tfft ${menuOpen ? "active-tfft" : ""}`}>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/products">Our Stones Collection</a>
          </li>
          <li>
            <a href="/contact">Contact Us</a>
          </li>
          {/* <li className="dropdown-tfft">
            <span>Know More</span>
            <ul className="dropdown-menu-tfft">
             
              <li>
                <a href="#">Gallery</a>
              </li>
            </ul>
          </li> */}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
